export function createElementFromHtml(html) {
    const $div = document.createElement('div');
    $div.innerHTML = html;

    return $div.firstElementChild;
}